var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-date-picker',{attrs:{"locale":_vm.$i18n.locale,"attributes":this.$data._attributes,"is-required":""},on:{"dayclick":_vm.dayClickHandler},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})}
var staticRenderFns = []

export { render, staticRenderFns }